import { Component } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { PlatformService } from 'src/shared/services/platform.service';
import { UserProfile } from 'src/shared/models/user-profile.model';

@Component({
    template: `
        <main class="page-content">
            <h1>{{notFoundText}}</h1>
        </main>
    `,
    styleUrls: ['not-found.component.scss'],
})

export class NotFoundComponent {
    user: UserProfile;
    notFoundText: string;
	
	private _unsubscribe$ = new Subject<void>();

	constructor(private _platformService: PlatformService) { }

	async ngOnInit(): Promise<void> {
		this._platformService.userProfile$
		.pipe(takeUntil(this._unsubscribe$))
		.subscribe(async (userProfile: UserProfile) => {
			this.user = userProfile;
			if (userProfile) {
				this.notFoundText = 'Page Not Found';
			}            
		});
	}

	ngOnDestroy(): void {
		this._unsubscribe$.next();
		this._unsubscribe$.complete();
	}

}
